import { CalendarDays } from "lucide-react";

const fmt = (iso) => (iso ? new Date(`${iso}T00:00:00`).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "");

/** One consistent "what dates does this table cover" line for every panel.
 *  Pass `range` (global picker) or a custom `label` + `note` for independent windows. */
export default function PeriodBadge({ range, label, note, className = "" }) {
  const text = label || (range?.label ? range.label : range?.start ? `${fmt(range.start)} → ${fmt(range.end)}` : "");
  if (!text) return null;
  const global = !label;
  return (
    <div
      className={`bm-eyebrow flex items-center gap-1.5 flex-wrap ${global ? "text-neutral-600" : "text-[#c72c2c]"} ${className}`}
      data-testid="period-badge"
    >
      <CalendarDays size={11} className="shrink-0" />
      <span className="text-[#0a0a0a] normal-case tracking-normal font-mono-bm text-xs">{text}</span>
      <span>· {global ? "from the date picker" : `own window${note ? ` — ${note}` : ""}`}</span>
    </div>
  );
}
